export default __webpack_public_path__ + "static/media/Menu_Hoodie_Snap.7d3a0127.svg";